module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Thunder-night-ab6125d3ed0592bdf940824d76a0d90a.svg";